import React, {PropTypes} from "react";
import Banner from "../../components/common/Banner";
import Navigation from "../../components/common/Navigation";
import Footer from "../../components/common/utils/Footer";
import {connect} from 'react-redux';
import axios from 'axios';

class AnnouncementsHome extends React.Component {

  constructor(props) {
    super(props);
    this.state={banner: "Announcements",options: [
    ]}
    this.changeBanner = this.changeBanner.bind(this);
  }
  componentDidMount()
  {
    let status='inactive';
    setTimeout(()=>{axios.get(process.env.REQ_URL + "/chatter/myDogFooding", {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      console.log(response.data.data);
      status= response.data.data;
      let options=[];
      if(status=='active')
      {
        options=[{
          text: "Announcements",
          active: true,
          url: "#/1/announcements",
          url2: "#/1/announcements/announcementsHome"
        },{

            text: "Chatter",
            active: true,
            url: "#/1/announcements/chatter",
            url2: "#/1/announcements/chatter"

        },
          {
            text: "Quikr Inspectr",
            active: true,
            url: "#/1/announcements/quikrInspectr",
            url2: "#/1/announcements/quikrInspectr"
          }
        ];}
      else
      {
        options=[
          {
            text: "Announcements",
            active: true,
            url: "#/1/announcements",
            url2: "#/1/announcements/announcementsHome"
          },
          {

            text: "Chatter",
            active: true,
            url: "#/1/announcements/chatter",
            url2: "#/1/announcements/chatter"

          }]
      }


      if(this.props.employee!=null)
      {
        debugger;
        if(this.props.employee.inspector || this.props.employee.announcement)
          options.push({
            text: "Create New",
            active: true,
            url: "#/1/announcements/createNew",
            url2: "#/1/announcements/createNew"
          })


      }
      this.setState({options: options})

    }).catch((error) => {

    });},500);

  }
  componentWillReceiveProps(props)
  {

    /*let options=this.state.options;
    if(this.state.options.length==2)

    if(props.employee!=null)
    {
      debugger;
      if(props.employee.inspector || props.employee.announcement)
        options= [
          {
            text: "Announcements",
            active: true,
            url: "#/1/announcements",
            url2: "#/1/announcements/announcementsHome"
          },
          {
            text: "Quikr Inspector",
            active: true,
            url: "#/1/announcements/quikrInspector",
            url2: "#/1/announcements/quikrInspector"
          },
          {
            text: "Create New",
            active: true,
            url: "#/1/announcements/createNew",
            url2: "#/1/announcements/createNew"
          }

        ];
    }
     this.setState({options: options})*/

  }
  changeBanner(text)
  {
    this.setState({banner: text})
  }

  render() {
    return (<div>
        <Banner name={this.state.banner}/>
        <div className="container">
          <div className="wrapper-1">
            <div className="row clearfix">
              <div className="col-xs-12">
                <div id="tab_content">
                  <Navigation options={this.state.options}/>
                  <div className="tab-content responsive" style={{padding: 0}}>
                    <div role="tabpanel" className="tab-panel">
                      <div className="row clearfix">

                        <div className="inner-col-wrap inner-table-wrap ">
                          {React.cloneElement(this.props.children, {
                            employee: this.props.employee,
                            changeBanner: this.changeBanner,

                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer/>
      </div>
    );
  }
}


AnnouncementsHome.defaultProps = {

}
function mapStateToProps(state,ownState)
{
  return {
    employee: state.emp[0]
  }
}
AnnouncementsHome.propTypes = {};

export default connect(mapStateToProps)(AnnouncementsHome);





/** WEBPACK FOOTER **
 ** ./src/feature/announcements/AnnouncementsHome.js
 **/